import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import VisibilityIcon from '@material-ui/icons/Visibility';
import NoParamNoReturnCallback from '@interfaces/NoParamNoReturnCallback';

const useDocRowStyles = makeStyles(theme => ({
	row: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		border: '0.5px solid rgba(0, 0, 0, 0.12)',
		borderRadius: '4px',
		padding: theme.spacing(1),
		marginTop: theme.spacing(1),
		gap: theme.spacing(1),
	},
	nameBox: {
		flex: 'auto 1 1',
		wordBreak: 'break-word',
	},
	buttonsBox: {
		'flex': 'auto 0 0',
		'gap': theme.spacing(1.5),
		'display': 'flex',
		'& .MuiButtonBase-root': {
			padding: 0,
		}
	},
	deleteIcon: {
		fill: theme.palette.error.light,
	},
	previewIcon: {
		fill: theme.palette.primary.main,
	},
}));

interface DocumentRowProps {
	name: string;
	handleDeleteSelectedDoc: NoParamNoReturnCallback;
	handleOpenPreview?: NoParamNoReturnCallback;
}

export const DocumentRow: React.FC<DocumentRowProps> = ({
	name,
	handleDeleteSelectedDoc,
	handleOpenPreview,
}) => {
	const classes = useDocRowStyles();

	return (
		<Box className={classes.row}>
			<Box className={classes.nameBox}>
				<Typography variant="body2">{name}</Typography>
			</Box>
			<Box className={classes.buttonsBox}>
				{handleOpenPreview && (
					<IconButton
						data-field="preview-document-button"
						onClick={handleOpenPreview}
						aria-label={`Preview document: ${name}`}
					>
						<VisibilityIcon
							className={classes.previewIcon}
							fontSize="medium"
						/>
					</IconButton>
				)}
				<IconButton
					data-field="delete-document-button"
					onClick={handleDeleteSelectedDoc}
					aria-label={`Delete document: ${name}`}
				>
					<DeleteRoundedIcon
						className={classes.deleteIcon}
						fontSize="medium"
					/>
				</IconButton>
			</Box>
		</Box>
	);
};
